import _ from 'lodash';
import { Entity } from '../constants';
import { AllIds, MetaIds, Type } from '../constants/Entity';
import { EntityMapper } from '../mappers';
import { EntityMapperType } from '../mappers/Entity';

const entityIdKeys = Object.values<EntityMapperType>(EntityMapper).map((orderType) => orderType.id);

/**
 * Finds the existing order id and returns the id key
 */
export const getOrderIdKeyById = (objWithOrder: {
  salesOrderId?: number;
  purchaseOrderId?: number;
  workOrderId?: number;
  buySellOrderId?: number;
}) => {
  const orderIdKey = entityIdKeys.find((key) => {
    return !!objWithOrder[key as keyof typeof objWithOrder];
  });

  return orderIdKey;
};

/**
 * Finds the existing order id and returns the order type
 */
export const getOrderTypeById = (objWithOrder: {
  salesOrderId?: number | null;
  purchaseOrderId?: number | null;
  workOrderId?: number | null;
  buySellOrderId?: number | null;
}) => {
  const orderType = Object.keys(EntityMapper).find((orderType) => {
    const id = EntityMapper[orderType as Entity.Type].id;

    return !!objWithOrder[id as keyof typeof objWithOrder];
  });

  return orderType;
};

export const getOrderByPresense = (objWithOrder: {
  purchaseOrder?: unknown;
  salesOrder?: unknown;
  workOrder?: unknown;
  buySellOrder?: unknown;
}) => {
  const { purchaseOrder, salesOrder, workOrder, buySellOrder } = objWithOrder;
  const order = purchaseOrder || salesOrder || workOrder || buySellOrder;

  return order;
};

export function selectFromReceipts<T>(objects: { bill?: T; payment?: T }[]): (T & { type: Entity.Type })[] {
  const selected: (T & { type: Entity.Type })[] = [];

  for (const objWithReceipts of objects) {
    if (objWithReceipts.bill) {
      selected.push({ ...objWithReceipts.bill, type: Type.BILL });
    }
    if (objWithReceipts.payment) {
      selected.push({ ...objWithReceipts.payment, type: Entity.Type.PAYMENT });
    }

    if (selected.length !== 0) {
      return selected;
    }
  }

  if (selected.length === 1 && selected[0].type === Entity.Type.PAYMENT) {
    console.log(`entity check`, objects);
  }

  return selected;
}

export function extractMetaIds(metaLinked: MetaIds): MetaIds {
  return _.pickBy(
    { paymentId: metaLinked?.paymentId, receiptAdjustmentId: metaLinked?.receiptAdjustmentId },
    _.identity
  );
}

export function extractAllIds(idLinked: AllIds): AllIds {
  return _.pickBy({ billId: idLinked?.billId, ...extractMetaIds(idLinked) }, _.identity);
}
